<template>
  <div>
    <AiHead></AiHead>
    <el-form class="password">
      <div class="password__prompt">
        <p style="font-size: 28px; font-weight: 700;">重设密码</p>
      </div>
      <div class="password__input-1">
        <el-input v-model="newPwd" placeholder="请输入新密码, 8-20个字符" show-password/>
      </div>
      <div class="password__input-2">
        <el-input v-model="confirmPwd" placeholder="请再次输入新密码" show-password/>
      </div>
      <div class="password__login" v-loading="loading">
        <el-button id="el-button" type="primary" @click="reset">登录</el-button>
      </div>
    </el-form>
    <AiBottomIcp></AiBottomIcp>
  </div>
</template>
<script>
  import md5 from 'js-md5'
  import AiHead from '../components/AI-Head.vue'
  import AiBottomIcp from '../components/AI-Bottom-ICP'
  export default{
    components: {
      AiHead,
      AiBottomIcp,
    },
    data() {
      return {
        salt: 'aigenai-2023-!@#$qweRTYuioPASdfgHJKlzxCVBnm', // 加密盐
        userName: this.$route.query.userName,
        newPwd: '',
        confirmPwd: '',
        loading: false,
      };
    },
    methods:{
      reset(){
        if (!this.newPwd) {
          this.$message({message: '请输入新密码！', type: 'warning'});
          return
        }
        if (this.newPwd.length < 8 || this.newPwd.length > 20) {
          this.$message({message: '新密码格式有误，请重新输入！', type: 'warning'});
          return
        }
        if (!this.confirmPwd) {
          this.$message({message: '请输入确认密码！', type: 'warning'});
          return
        }
        if (this.newPwd !== this.confirmPwd) {
          this.$message({message: '新密码与确认密码不一致！', type: 'warning'});
          return
        }
        this.loading = true
        // 重置密码
        this.resetPwd()
      },
      // 重置密码
      resetPwd(){
        let data = {userName: this.userName, password: md5(this.salt+this.confirmPwd)}
        this.$http.post('/aigenai/resetPwd', data).then(
          res=>{
            if (res.code !== 0){
              this.loading = false
              return
            }
            // 已重置密码成功
            localStorage.setItem('reset', false)
            // 获取once值
            this.getOnce()
          }
        ).catch(err=>{console.log('err', err)})
      },
      // 获取once值
      getOnce(){
        this.$http.get('/aigenai/once').then(
          res=>{
            if (res.code !== 0 || !res.data) {
              this.loading = false
            }else{
              /* 登录： post请求的数据以对象的形式传输 */
              this.toLogin(res.data)
            }
          }
        ).catch(err=>{console.log('err', err)})
      },
      // 登录
      toLogin(once){
        // 加盐
        // 处理密码：md5加密
        let encryPwd = md5(md5(this.salt+this.confirmPwd) + once)
        this.$http.post('/aigenai/login',  {userName: this.userName, password: encryPwd}).then(
          res=>{
            this.loading = false
            if (res.code !== 0) return
            // 进入主页
            this.$router.push({path:'/home'}, ()=>{})
            // 缓存用户id
            localStorage.setItem('userId', res.data.id)
            localStorage.setItem('userName', res.data.userName)
            // 将登录信息存到内存中
            let userInfo = {...res.data, logged: true}
            this.$store.commit('storeUserInfo', userInfo)
          }
        ).catch(err=>{console.log('err', err)})
      },
    },
    // 组件路由守卫（进入组件前执行）
    beforeRouteEnter(to, from, next){
      if (localStorage.getItem('reset') == 'true'){
        // 可进入重设密码页面
        next()
      } else {
        // 不能通过路径直接进入重设密码页面
        window.location.href = "/login"
      }
    },
  }
</script>
<style lang="less" scoped>
.password{
  position: absolute;
  display: flex;
  flex-direction: column;
  min-width: 320px;
  min-height: 300px;
  left:50%;
  top:35%;
  margin-left:-150px;
  margin-top:-100px;
  &__prompt{
    text-align: left;
  }
  &__input-1{
    margin-top: 50px;
  }
  &__input-2{
    margin-top: 30px;
  }
  &__login{
    margin-top: 40px;
  }
}
#el-button{
  width: 100%; 
  background-color: #0f62fe
}
</style>